export const MAX_ACCESS_CARD_GENERATION_BATCH_SIZE = 500;

export const toggleLoadedGuestSelection = (
  selectedGuestIDs: ReadonlySet<string>,
  loadedGuestIDs: readonly string[],
): Set<string> => {
  const next = new Set(selectedGuestIDs);
  const allLoadedSelected =
    loadedGuestIDs.length > 0 &&
    loadedGuestIDs.every((guestID) => next.has(guestID));

  loadedGuestIDs.forEach((guestID) => {
    if (allLoadedSelected) next.delete(guestID);
    else next.add(guestID);
  });
  return next;
};
